import styled from 'styled-components';
import {List} from 'global/styles/styles.js';
import {rem} from 'polished';

const FavouritesHeaderBackground = ({theme:{$favouritesHeaderBackground}}) => `${$favouritesHeaderBackground}`;
const FavouritesHeaderColor = ({theme:{$favouritesHeaderColor}}) => `${$favouritesHeaderColor}`;

const baseFont = `12px`;
const S = {};

S.FavouritesWrapper = styled.div`
`;


S.FavouritesHeader = styled.div`
display: ${({active})=>(active?`none`:`flex`)};
background-color: ${FavouritesHeaderBackground};
    min-height: 42px;
    margin-bottom: 2px;
        font-weight: 700;
            font-size: 0.875rem;
    padding: 0 16px;
    color: ${FavouritesHeaderColor};
`;

S.FavouritesBody = styled.div``;

S.FavouritesList = styled(List)`
margin: 8px 0;
`;

S.FavouritesItem = styled.li`
    background: #fff;
    color: #000;
    font-size: 12px;
    border-radius: 3px;
    padding: 0 1rem;
    font-weight: 600;
    margin: 0 16px 2px 16px;
        min-height: 42px;
        display: flex;
        
`;

S.Title = styled.div`
    padding: .2rem 0;
        max-width: 100%;
        flex-grow: 1;
        align-self: center;
`;



S.EventsCount = styled.div`
align-self: center;
background-color: #D32F2F;
    color: #fff;
    border-radius: 2px;
    padding: 3px;
    min-width: 25px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    margin-left: auto;
`;

S.LeagueName = styled.div`
    flex-basis: 75%;
    max-width: 75%;
        padding: .2rem 0;
        font-weight: 600;
            color: #000;
    font-size: 12px;
    align-self: center;
`;

S.ParticipaneName = styled(S.LeagueName)``;

S.FavouriteIcon = styled.div`
width: ${rem('25px', baseFont)};
height: auto;
    padding: 0;
align-self: center;
    flex-shrink: 0;

    margin-right: 10px;

    & > svg {
        height: 100%;
    }
`;

S.HeaderFavouriteIcon = styled(S.FavouriteIcon)`
width: 22px;
max-width: 2.5rem;
    padding: .5rem;
    font-size: 1.2rem;
    padding-left: 0;
    align-self: center;
`;

S.Arrow = styled.div`
    display: flex;
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    align-items: center;
    justify-content: flex-end;
`;


S.ArrowIcon = styled.i`
    width: 12px;
    height: 7.4px;
    margin-top: 4px;
    margin-left: 16px;
    transition: transform 0.25s, -webkit-transform 0.25s;
    -webkit-mask: url(http://localhost:2111/images/svg/arrow-down-white.svg) no-repeat 0 0;
    background-color: #000;
   
`;


export default S;
